// extracted by mini-css-extract-plugin
module.exports = {"contianer":"spinner_contianer__O5176","spinner":"spinner_spinner__2Iavo","spin":"spinner_spin__l0tok","medium":"spinner_medium__jvX6e"};